import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";
import {BruteForce} from "../BruteForce";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {SimpleReelModel} from "../../core/reel/simplereel/SimpleReelModel";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {BruteForceSound} from "../sound/BruteForceSound";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";
import {BLEND_MODES} from "pixi.js";

export class BruteForceGameIntro extends PIXI.Container implements StageLayer {
    private _introTl: gsap.core.Timeline;
    private _prevSpaceBarSettings: boolean;
    private _onePlayerOnlyText: PIXI.Text;
    private _startingText: PIXI.Text;
    private _highScoreText: PIXI.Text;
    private _highScoreNo: PIXI.Text;
    private _bg: PIXI.Graphics;
    private _startGlitch: TimelineSprite;
    private _startCount: number = 0;

    constructor() {
        super();
        this.name = "GameIntroView";

        this._bg = new PIXI.Graphics();
        this._bg.beginFill(0x000000, 1);
        this._bg.drawRect(-60, -30, 725, 576);
        this._bg.endFill();
        this._bg.name = "blackScreenBG";
        this._bg.position.set(60, 95);

        this.addChild(this._bg);


        this._startGlitch = new TimelineSprite(BruteForce.assetLoader.getTextures("startGlitch"));
        this._startGlitch.hide();
        this._startGlitch.blendMode = BLEND_MODES.ADD;
        this._startGlitch.scale.set(1.2, 1.2);

        this.addChild(this._startGlitch)


        this._onePlayerOnlyText = new PIXI.Text("", new PIXI.TextStyle(
            {
                fill: "#ffffff",
                fontFamily: "ARCADECLASSIC",
                wordWrap: false,
                fontWeight: FontWeight.BOLD,
                fontSize: 30,
                letterSpacing: 5,
            }));

        this._onePlayerOnlyText.position.set(210, 120);
        this._onePlayerOnlyText.name = `oneplayerOnlytext`;
        this.addChild(this._onePlayerOnlyText);


        this._startingText = new PIXI.Text("", new PIXI.TextStyle(
            {
                fill: "#FEEB04",
                fontFamily: "ARCADECLASSIC",
                wordWrap: false,
                fontWeight: FontWeight.BOLD,
                fontSize: 50,
                letterSpacing: 5,
            }));

        this._startingText.position.set(210, 270);
        this._startingText.name = "StartingText";
        this.addChild(this._startingText);

        this._highScoreText = new PIXI.Text("", new PIXI.TextStyle(
            {
                fill: "#ffffff",
                fontFamily: "ARCADECLASSIC",
                wordWrap: false,
                fontWeight: FontWeight.BOLD,
                fontSize: 35,
                letterSpacing: 5,
            }));

        this._highScoreText.position.set(170, 430);
        this._highScoreText.name = "highscoreText";
        this.addChild(this._highScoreText);

        this._highScoreNo = new PIXI.Text("", new PIXI.TextStyle(
            {
                fill: "#ffffff",
                fontFamily: "ARCADECLASSIC",
                wordWrap: false,
                fontWeight: FontWeight.BOLD,
                fontSize: 45,
                letterSpacing: 5,
            }));

        this._highScoreNo.position.set(280, 480);
        this._highScoreNo.name = "40000xText";
        this.addChild(this._highScoreNo);

        this.alpha = 0;

    }


    public startIntro(): void {
        this._introTl = gsap.timeline({
            onStart: () => {
                this.interactive = true;
                this._prevSpaceBarSettings = BruteForce.apiPlugin.settings.get(APISetting.USE_SPACE_TO_SPIN, false);
                BruteForce.apiPlugin.settings.set(APISetting.USE_SPACE_TO_SPIN, false);
                BruteForce.keypadPlugin.toggleVisibility(false);
                BruteForceSound.fadeMusic(0, 100);
                BruteForceSound.playTrack(BruteForceSound.GAMEINTRO);
                BruteForce.foregroundElements.playArcadeMachineAnimation("gameEnter", false, "logo_nolimitCity", false);
            }
        });
        this._introTl.to(this, {duration: 0.01, alpha: 1});
        // this._introTl.to(this, {duration: 0.5});
        this._introTl.add(this.textAppearing(this._onePlayerOnlyText, "ONE PLAYER ONLY", true));
        this._introTl.to(this, {duration: 0.2});
        this._introTl.add(this.blinkAnimation(this._onePlayerOnlyText, 0), ">");
        this._introTl.add(this.textAppearing(this._startingText, "STARTING ...", false), "<");
        this._introTl.add(this.textAppearing(this._highScoreText, "HIGHSCORE TO BEAT", true), "<");
        this._introTl.add(this.textAppearing(this._highScoreNo, "40000x", true), "<");
        this._introTl.add(() => {
            this.blinkAnimation(this._highScoreText, 0);
            this.blinkAnimation(this._highScoreNo, 0);
        }, ">");
        this._introTl.to(this._bg, {duration: 0.5, alpha: 0}, 1.85);
        this._introTl.to([this._startingText, this._highScoreText, this._highScoreNo, this._onePlayerOnlyText], {
            duration: 0.5,
            alpha: 0
        }, 1);
        this._introTl.add(<gsap.core.Timeline><unknown>this._startGlitch.getAnimationAutoShowHide(), "<0.4");
        this._introTl.to(this, {duration: 0.001, alpha: 0, ease: "power1.out"}, ">");
        this._introTl.add(BruteForce.backgroundElements.introBgTravel(), ">");
        this._introTl.add(BruteForce.allreelsView.dropReelSetAnimation(), "<0.9");
        this._introTl.add(() => {
            BruteForce.foregroundElements.playArcadeMachineAnimation("logo_brute", false);
            this.stopIntro();
        }, 3.8443);

        this.on('pointerdown', () => {
            this.stopIntro();
        });


    }

    private stopIntro(): void {
        this._startCount++;
        if(this._startCount===1) {
            this.interactive = false;
            // console.log(this._introTl.totalDuration());
            this._introTl.totalProgress(1);
            this._introTl.kill();
            this.destroy({children: true});
            BruteForce.keypadPlugin.toggleVisibility(true);
            BruteForceSound.stopSound(BruteForceSound.GAMEINTRO);
            BruteForceSound.stopSound(BruteForceSound.REEL_CRASH);
            BruteForceSound.fadeMusic(1, 200);
            NolimitApplication.removeLayer("CharacterIntroView");
            BruteForce.apiPlugin.settings.set(APISetting.USE_SPACE_TO_SPIN, this._prevSpaceBarSettings);
            BruteForce.foregroundElements.setInteractiveButton(true);
            BruteForce.allreelsView.reelModels.forEach((reel: SimpleReelModel) => {
                reel.setInteractiveSymbols(true);
            });
        }
    }

    private blinkAnimation(value: PIXI.Text, repeatValue: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline({repeat: repeatValue});
        value.visible = true;

        if (BruteForce.apiPlugin.gameClientConfiguration.replaceWincapInfo) {
            this._highScoreText.visible = false;
            this._highScoreNo.visible = false;
        }

        tl.to(value, {
            duration: 0.5,
            alpha: 0.5,
            ease: "none"
        });
        tl.to(value, {
            duration: 0.5,
            alpha: 1,
            ease: "none"
        }, ">");


        return tl;
    }

    private textAppearing(value: PIXI.Text, dataText: string, fastAppear: boolean): gsap.core.Timeline {
        const textTl: gsap.core.Timeline = gsap.timeline();
        value.text = "";
        let data: string = dataText;
        let appearTime: number = fastAppear ? 0 : 0.05;
        for (let i = 0; i < data.length; i++) {
            textTl.add(() => {
                value.text += data[i];
            }, `+=${appearTime}`);
        }
        return textTl;
    }

}